import axios from '@/plugins/axios';
import { endpoint } from './apiConstants';
import { TrnSearchMyPageAddRequest } from '@/types/request';

export const getCareerId = async () => {
  const res = await axios.get(endpoint.getCareerId);
  return res.data;
};

export const getListSerchMypage = async (limit?: number) => {
  const res = await axios.get(endpoint.getListSerchMypage + `?limit=${limit ?? 0}`);
  return res.data;
};
export const getSingleSerchMypage = async (serchId: number) => {
  const replacedEndpoint = endpoint
                          .getSingleSerchMypage
                          .replace('{serchId}', String(serchId));
  const res = await axios.get(replacedEndpoint);
  return res.data;
};
export const deleteSerchMypage = async (serchId: number) => {
  const replacedEndpoint = endpoint
                          .deleteSerchMypage
                          .replace('{serchId}', String(serchId));
  const res = await axios.delete(replacedEndpoint);
  return res.data;
};
export const postSerchMypage = async (postParams: TrnSearchMyPageAddRequest) => {
  const res = await axios.post(endpoint.addSerchMypage, postParams);
  return res.data;
};
export const getMaxId = async () => {
  const res = await axios.get(endpoint.getMaxId);
  return res.data;
};